<!-- Start Public Information Page Section -->
<main class="ecb-web-public-page">

  <!-- Start Locations Banner Section -->
  <section class="ecb-web-location-banner-section">
    <div class="ecb-web-location-banner-overlay"></div>

    <div class="container ecb-web-location-banner-container hero-inner">
      <div class="row align-items-center">

        <!-- Start Locations Banner Content Section -->
        <div class="col-12 col-lg-6">
          <div class="ecb-web-location-banner-content">

            <!-- Display the workplace health and safety category label. -->
            <span class="pill">About ECB</span>
            <!-- Display the main HSR Training heading. -->

            <h1>About Us</h1>

            <div class="ecb-web-voc-title-line"></div>

            <p>
              ECB Training Services is a leading Australian Registered Training Organisation delivering nationally
              recognised training across construction, mining, resources, and workplace safety. Our experienced industry
              professionals provide practical, high-quality learning that equips individuals with real-world skills. We
              are committed to building safer workplaces, stronger communities, and a highly skilled workforce.
            </p>

          </div>
        </div>
        <!-- End Locations Banner Content Section -->

      </div>
    </div>
  </section>
  <!-- End Locations Banner Section -->


  <!-- Start Training Location Section -->
  <section class="ecb-web-location-finder-section">
    <div class="container">

      <!-- Start Training Location Heading Section -->
      <div class="ecb-web-page-section-heading">
        <h2>
          Find a Training Location <span>Near You</span>
        </h2>

        <p>High quality training, local support.</p>
      </div>
      <!-- End Training Location Heading Section -->



      <!-- Start Location Feature Section -->
      <div class="ecb-web-location-feature-wrapper">
        <div class="row g-3 row-cols-1 row-cols-sm-2 row-cols-lg-3 row-cols-xl-6">

          <div class="col" *ngFor="
              let feature of locationFeatures;
              trackBy: trackById
            ">
            <article class="ecb-web-location-feature-card">
              <i [class]="feature.icon"></i>
              <h3>{{ feature.title }}</h3>
            </article>
          </div>

        </div>
      </div>
      <!-- End Location Feature Section -->

    </div>
  </section>
  <!-- End Training Location Section -->


  <!-- Start About Us Section -->
  <section class="ecb-web-about-section">
    <div class="container">

      <div class="ecb-web-about-panel">

        <!-- Start About Main Content Section -->
        <div class="row g-0">

          <!-- Start About Text Section -->
          <div class="col-12 col-lg-6">
            <div class="ecb-web-about-content">

              <h2>About ECB Training </h2>

              <p>
                ECB Training is a leading registered training organisation
                (RTO 41369) delivering nationally recognised training
                across Australia.
              </p>

              <p>
                We partner with industry to deliver practical, hands-on
                training that builds real skills and safer workplaces.
                Our courses are designed and delivered by experienced
                professionals with real industry experience.
              </p>

              <!-- Start About Feature List Section -->
              <ul class="ecb-web-about-feature-list">
                <li *ngFor="
                    let feature of aboutFeatures;
                    trackBy: trackById
                  ">
                  <i class="bi bi-check-circle-fill"></i>
                  <span>{{ feature.title }}</span>
                </li>
              </ul>
              <!-- End About Feature List Section -->

              <a href="#" class="btn ecb-web-about-button">
                Learn More About Us
              </a>

            </div>
          </div>
          <!-- End About Text Section -->


          <!-- Start About Image Section -->
          <div class="col-12 col-lg-6">
            <div class="ecb-web-about-image-wrapper">
              <img src="assets/images/locations/about_us_2.png" alt="ECB Training professional team"
                class="ecb-web-about-image">
            </div>
          </div>
          <!-- End About Image Section -->

        </div>
        <!-- End About Main Content Section -->


        <!-- Start About Statistics Section -->
        <div class="ecb-web-about-statistics">
          <div class="row g-0 row-cols-1 row-cols-sm-2 row-cols-lg-4">

            <div class="col" *ngFor="
                let statistic of statistics;
                trackBy: trackById
              ">
              <article class="ecb-web-about-statistic-card">

                <div class="ecb-web-about-statistic-icon">
                  <i [class]="statistic.icon"></i>
                </div>

                <div>
                  <h3>{{ statistic.value }}</h3>
                  <p>{{ statistic.label }}</p>
                </div>

              </article>
            </div>

          </div>
        </div>
        <!-- End About Statistics Section -->

      </div>

    </div>
  </section>
  <!-- End About Us Section -->


 


  <!-- Start Corporate Training Section -->
  <section class="ecb-web-corporate-section">
    <div class="container">

      <div class="row g-0 align-items-stretch">

        <!-- Start Corporate Training Content Section -->
        <div class="col-12 col-lg-8">
          <article class="ecb-web-corporate-content-panel">

            <div class="ecb-web-corporate-overlay"></div>

            <div class="ecb-web-corporate-content">

              <h2>Corporate Training</h2>

              <p>
                We partner with businesses to deliver customised training
                solutions that improve skills, productivity and safety.
              </p>

              <!-- Start Corporate Feature List Section -->
              <ul class="ecb-web-corporate-feature-list">
                <li *ngFor="
                    let feature of corporateFeatures;
                    trackBy: trackById
                  ">
                  <i class="bi bi-check-circle-fill"></i>
                  <span>{{ feature.title }}</span>
                </li>
              </ul>
              <!-- End Corporate Feature List Section -->

              <a href="#" class="btn ecb-web-corporate-button">
                Request a Proposal
              </a>

            </div>

          </article>
        </div>
        <!-- End Corporate Training Content Section -->


        <!-- Start Corporate Proposal Form Section -->
        <div class="col-12 col-lg-4">
          <article class="ecb-web-proposal-form-panel">

            <h3>Request a Corporate Training Proposal</h3>

            <p>
              Tell us about your training needs and we’ll create a
              solution for your team.
            </p>

            <form #proposalFormReference="ngForm" (ngSubmit)="submitProposal()">

              <!-- Start Full Name Field Section -->
              <div class="ecb-web-proposal-field">
                <input type="text" name="fullName" maxlength="250" class="form-control" placeholder="Full Name"
                  [(ngModel)]="proposalForm.fullName" required>
              </div>
              <!-- End Full Name Field Section -->


              <!-- Start Email Field Section -->
              <div class="ecb-web-proposal-field">
                <input type="email" name="email" maxlength="100" class="form-control" placeholder="Email Address"
                  [(ngModel)]="proposalForm.email" required email>
              </div>
              <!-- End Email Field Section -->


              <!-- Start Company Name Field Section -->
              <div class="ecb-web-proposal-field">
                <input type="text" name="companyName" maxlength="100" class="form-control" placeholder="Company Name"
                  [(ngModel)]="proposalForm.companyName">
              </div>
              <!-- End Company Name Field Section -->


              <!-- Start Requirement Field Section -->
              <div class="ecb-web-proposal-field">
                <textarea name="requirements" class="form-control" rows="4" placeholder="Training Requirements"
                  [(ngModel)]="proposalForm.requirements" required></textarea>
              </div>
              <!-- End Requirement Field Section -->


              <!-- Start Proposal Submit Button Section -->
              <button type="submit" class="btn ecb-web-proposal-submit-button" [disabled]="
                  proposalFormReference.invalid ||
                  isProposalSubmitting
                ">
                <span>
                  {{
                  isProposalSubmitting
                  ? 'Submitting...'
                  : 'Submit Request'
                  }}
                </span>

                <i class="bi" [ngClass]="
                    isProposalSubmitting
                      ? 'bi-arrow-repeat ecb-web-proposal-spinner'
                      : 'bi-send'
                  "></i>
              </button>
              <!-- End Proposal Submit Button Section -->


              <!-- Start Proposal Success Message Section -->
              <div class="ecb-web-proposal-success-message" *ngIf="isProposalSuccess">
                <i class="bi bi-check-circle-fill"></i>
                Your request was submitted successfully.
              </div>
              <!-- End Proposal Success Message Section -->

            </form>
            <div class="ecb-web-proposal-error-message" *ngIf="isProposalError">

              <i class="bi bi-exclamation-circle-fill"></i>

              Unable to submit your request. Please try again.

            </div>
          </article>
        </div>
        <!-- End Corporate Proposal Form Section -->

      </div>

    </div>
  </section>
  <!-- End Corporate Training Section -->



  <!-- Start Quick Start and Office Section -->
  <section class="ecb-web-start-office-section">
    <div class="container">

      <!-- Start Quick Start and Office Main Panel Section -->
      <div class="ecb-web-start-office-panel">
        <div class="row g-4 align-items-stretch">

          <!-- Start Office List Column Section -->
          <div class="col-12 col-lg-4">
            <article class="ecb-web-start-office-list-card">

              <!-- Start Melbourne Office Section -->
              <div class="ecb-web-start-office-item" *ngFor="
                let location of trainingLocations;
                trackBy: trackById
              ">

                <img [src]="location.image" [alt]="location.name" class="ecb-web-start-office-image">

                <div class="ecb-web-start-office-details">
                  <div class="ecb-web-office-header">
                    <h3>{{ location.name }}</h3>

                    <span class="ecb-web-start-office-badge" *ngIf="location.isHeadOffice">
                      Head Office
                    </span>

                  <!--   <span class="ecb-web-start-office-badge" *ngIf="!location.isHeadOffice">
                       
                    </span> -->
                  </div>

                  <p>{{ location.addressLineOne }}</p>
                  <p>{{ location.addressLineTwo }}</p>

                  <a href="tel:0387000123" class="ecb-web-start-office-phone">
                    {{ location.phone }}

                  </a>

                </div>

              </div>
              <!-- End Melbourne Office Section -->
            </article>
          </div>
          <!-- End Office List Column Section -->
          <!-- Start Quick Start CTA Column Section -->
          <div class="col-12 col-lg-8">
            <article class="ecb-web-start-office-cta">

              <!-- Start Quick Start CTA Content Section -->
              <div class="ecb-web-start-office-cta-content">
                <h2>Our Training</h2>

                <p>
                  ECB courses cover a range of mining, civil construction,
                  and resource industry sectors. Sessions are delivered
                  onsite, at ECB locations, or online, with individual and
                  group bookings available on request.​
                </p>
              </div>
              <!-- End Quick Start CTA Content Section -->

              <!-- Start Quick Start CTA Button Section -->
              <div class="ecb-web-start-office-button-area">

                <a routerLink="/course-qualifications" class="btn ecb-web-start-office-primary-button">
                  <span>Find a Course</span>
                  <i class="bi bi-arrow-right"></i>
                </a>

                <a routerLink="/contact-us" class="btn ecb-web-start-office-outline-button">
                  <span>Contact Us</span>
                  <i class="bi bi-arrow-right"></i>
                </a>

              </div>
              <!-- End Quick Start CTA Button Section -->

            </article>
          </div>
          <!-- End Quick Start CTA Column Section -->



        </div>
      </div>
      <!-- End Quick Start and Office Main Panel Section -->

    </div>
  </section>
  <!-- End Quick Start and Office Section -->



</main>
<!-- End Public Information Page Section -->